<style lang="stylus">
    .ivu-modal-confirm-head-title
        width 320px

    .file-save
        position fixed
        left 0
        right 0
        top 0
        height 60px
        padding 22px 0 10px 40px
        page_background()
        box-sizing border-box
        max-width 100%

        input
            box-sizing border-box
            resize none

        .fs-box
            max-width 100%

            .fsb
                display flex

                .name-div
                    justify-content center
                    align-items center
                    display flex
                    font-size 14px
                    color #000
                    font-weight 700
                    flex-shrink 0

                .input-div
                    margin-left 16px
                    height 28px
                    input
                        display inline-block
                        width 280px
                        height 28px
                        line-height 1.5
                        padding 4px 7px
                        padding-left 0
                        font-size 12px
                        text-indent 8px
                        border none
                        border-radius 6px
                        color #000
                        background-color #fff
                        background-image none
                        position relative
                        cursor text
                        outline none
                        border 1px solid transparent
                        &::placeholder
                            color #9e9e9e
                        &:hover
                            border-color #017fff !important
                        &:focus
                            border-color #017fff !important
                            box-shadow: 0px 0px 0px 2px rgba(1, 127, 255, 0.1) !important

                .button-div
                    position relative
                    display flex
                    flex-shrink 0
                    justify-content center
                    align-items center
                    height 28px
                    margin-left 16px
                    border-radius 6px
                    cursor pointer
                    user-select none
                    padding 0 16px
                    min-width 56px
                    background #017fff
                    color #fff

                    >p
                        max-width calc(100% - 32px)
                        white-space nowrap
                        overflow hidden
                        text-overflow ellipsis

                    &:hover
                        background #006adf

    .file-save.dark-theme__saver
        background #1e1e20
        color #fff
        border-top none
        .fs-box
            .fsb
                .name-div
                    color #dadada
                .input-div
                    input
                        background rgba(255, 255, 255, 0.1);
                        box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
                        color #fff
                        &:hover
                            border: 1px solid #017FFF;
                            box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
                        &:focus
                            border: 1px solid #017FFF;
                            box-shadow: 0px 0px 0px 2px rgba(1, 127, 255, 0.3)
</style>

<template>
    <div class="file-save" :class="{ 'dark-theme__saver': isPCDarkMode == 2 }">
        <div class="fs-box">
            <div class="fsb">
                <label for="name" class="name-div">{{ $t("fileName") }}</label>
                <div class="input-div">
                    <input ref="nameIpt" v-model="savename" name="name" @keypress.enter="saveNewFile" ondragstart="return false" />
                </div>

                <div class="button-div" @click="saveNewFile">
                    <div type="primary">
                        {{ $t("Save") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<i18n>
{
  "zh": {
    "fileName": "文件名：",
    "nullName": "名称不可为空",
    "errorName": "文件名不能包含特殊字符(& % $ 😊等)",
    "Save": "保存",
    "fileNameRepeatError": "已存在同名文件！",
    "fileOpening": "文件正在打开中...",
    "networkError": "网络错误，请重试！",
    "confirm": {
      "title": "覆盖或取消",
      "fileContent": "是否覆盖 ",
      "folderContent": "目标文件夹中已存在同名文件夹，是否要覆盖？"
    },
    "saving": "保存中…",
    "okText": "确定",
    "cancelText": "取消"
  },
  "en": {
    "fileName": "Name:",
    "nullName": "Name cannot be empty.",
    "errorName": "File name can't contains special character, such as & % $ 😊, etc.",
    "Save": "Save",
    "fileNameRepeatError": "A file with the same file name already exists!",
    "fileOpening": "Opening...",
    "networkError": "Network error, please try again!",
    "confirm": {
      "title": "Overwrite or Cancel",
      "fileContent": "Are you sure you want to overwrite it?",
      "folderContent": "A folder with the same name already exists in the destination folder. Do you want to overwrite it?"
    },
    "saving": "Saving...",
    "okText": "OK",
    "cancelText": "Cancel"
  },
  "de": {
    "fileName": "Name:",
    "nullName": "Name darf nicht leer sein",
    "errorName": "File name can't contains special character, such as & % $ 😊, etc.",
    "Save": "Sichern",
    "fileNameRepeatError": "Eine Datei mit demselben Dateinamen ist bereits vorhanden!",
    "fileOpening": "Die Datei wird geöffnet...",
    "networkError": "Netzwerkfehler, bitte versuchen Sie es erneut!",
    "confirm": {
      "title": "Überschreiben oder abbrechen",
      "fileContent": "Sind Sie sicher, dass Sie es überschreiben möchten ",
      "folderContent": "Ein Ordner mit demselben Namen ist bereits im Zielordner vorhanden. Willst du es überschreiben?"
    },
    "saving": "Sichern...",
    "okText": "Sichern",
    "cancelText": "Abbrechen"
  },
  "fr": {
    "fileName": "Nom:",
    "nullName": "Nom ne peut pas être vide",
    "errorName": "File name can't contains special character, such as & % $ 😊, etc.",
    "Save": "Entregistrer",
    "fileNameRepeatError": "Un fichier du même nom existe déjà !",
    "fileOpening": "Le fichier est en cours de s'ouvrir...",
    "networkError": "Erreur réseau, veuillez réessayer !",
    "confirm": {
      "title": "Remplacer or Annuler",
      "fileContent": "Voulez-vous le remplacer ?",
      "folderContent": "Un dossier du même nom existe déjà dans le dossier de destination. Voulez-vous le remplacer ?"
    },
    "saving": "Entregistrement en cours...",
    "okText": "Créer",
    "cancelText": "Annuler"
  },
  "es": {
    "fileName": "Nombre:",
    "nullName": "El nombre no puede estar vacío",
    "errorName": "File name can't contains special character, such as & % $ 😊, etc.",
    "Save": "Guardar",
    "fileNameRepeatError": "¡Ya existe un archivo con el mismo nombre de archivo!",
    "fileOpening": "El archivo se está abriendo...",
    "networkError": "Error de conexión, ¡por favor inténtelo de nuevo!",
    "confirm": {
      "title": "Sobrescribir o Cancelar",
      "fileContent": "¿Está seguro de que desea sobrescribirlo?",
      "folderContent": "Ya existe una carpeta con el mismo nombre en la carpeta de destino. ¿Desea sobreescribirlo?"
    },
    "saving": "Guardando...",
    "okText": "Confirmar",
    "cancelText": "Cancelar"
  },
  "jp": {
    "fileName": "ファイル名:",
    "nullName": "名前は空にできません",
    "errorName": "File name can't contains special character, such as & % $ 😊, etc.",
    "Save": "保存",
    "fileNameRepeatError": "同じ名のファイルは既に存在します！",
    "fileOpening": "ファイルを開いている…",
    "networkError": "ネットワークエラー、後でもう一度お試みください！",
    "confirm": {
      "title": "上書きまたはキャンセル",
      "fileContent": "同じ名のファイルがコピー先フォルダーに既に存在します。上書きしますか。",
      "folderContent": "同じ名のフォルダーがコピー先フォルダーに既に存在します。上書きしますか。"
    },
    "saving": "保存中…",
    "okText": "確認",
    "cancelText": "キャンセル"
  },
  "it": {
    "fileName": "Nome:",
    "nullName": "Si prega di riempire il campo del nome.",
    "errorName": "Il nome del file non può contenere caratteri speciali, come &% $ 😊, ecc.",
    "Save": "Salva",
    "fileNameRepeatError": "Esiste già un file con lo stesso nome!",
    "fileOpening": "Apertura...",
    "networkError": "Errore di rete. Si prega di riprovare!",
    "confirm": {
      "title": "Sovrascrivi o Annulla",
      "fileContent": "Confermi di voler sovrascrivere?",
      "folderContent": "È presente una cartella con lo stesso nome nella cartella di destinazione. Desideri sovrascriverla?"
    },
    "saving": "Salvataggio...",
    "okText": "OK",
    "cancelText": "Annulla"
  },
  "pt": {
    "fileName": "Nome:",
    "nullName": "Nome não pode estar vazio.",
    "errorName": "File name can't contains special character, such as & % $ 😊, etc.",
    "Save": "Salvar",
    "fileNameRepeatError": "Já há um arquivo com o mesmo nome!",
    "fileOpening": "Abrindo...",
    "networkError": "Erro de rede, por favor, tente novamente!",
    "confirm": {
      "title": "Substituir ou Cancelar",
      "fileContent": "Tem a certeza de que deseja efetuar a substituição?",
      "folderContent": "Já há uma pasta com o mesmo nome na pasta de destino. Você deseja substituí-la?"
    },
    "saving": "Salvando...",
    "okText": "OK",
    "cancelText": "Cancelar"
  },
  "tw": {
    "fileName": "檔案名：",
    "nullName": "名稱不可為空",
    "errorName": "檔案名不能包含特殊字符(& % $ 😊等)",
    "Save": "儲存",
    "fileNameRepeatError": "已存在同名檔案！",
    "fileOpening": "檔案正在打開中...",
    "networkError": "網絡錯誤，請重試！",
    "confirm": {
      "title": "覆蓋或取消",
      "fileContent": "是否覆蓋 ",
      "folderContent": "目標資料夾中已存在同名資料夾，是否要覆蓋？"
    },
    "saving": "儲存中…",
    "okText": "取消",
    "cancelText": "確定"
  },
  "kr": {
    "fileName": "파일이름：",
    "nullName": "이름은 비워 둘 수 없습니다.",
    "errorName": "파일 이름에 특수 기호(& % $ 😊등)을 포함할 수 없습니다.",
    "Save": "저장",
    "fileNameRepeatError": "같은 이름의 파일이 이미 있습니다!",
    "fileOpening": "파일 여는 중..",
    "networkError": "네트워크 오류입니다. 다시 시도하세요~",
    "confirm": {
      "title": "덮어쓰기 또는 취소",
      "fileContent": "덮어 쓰시겠습니까?",
      "folderContent": "같은 이름의 폴더가 대상 폴더에 이미 있습니다. 덮어 쓰시겠습니까?"
    },
    "saving": "저장 중…",
    "okText": "확인",
    "cancelText": "취소"
  },
  "id": {
    "fileName": "Nama:",
    "nullName": "Nama tidak boleh kosong.",
    "errorName": "Nama file tidak boleh berisi karakter khusus, seperti & % $ 😊, dll.",
    "Save": "Simpan",
    "fileNameRepeatError": "File dengan nama yang sama sudah ada!",
    "fileOpening": "Membuka ....",
    "networkError": "Terjadi kesalahan jaringan. Coba lagi!",
    "confirm": {
      "title": "Timpa atau Batalkan",
      "fileContent": "Anda yakin ingin menimpanya?",
      "folderContent": "Folder dengan nama yang sama sudah ada di folder tujuan ini. Anda ingin menimpanya?"
    },
    "saving": "Menyimpan ....",
    "okText": "OKE",
    "cancelText": "Batalkan"
  }
}
</i18n>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { checkFileName } from "@/public/utils/tool";

    @Component({})
    export default class SaveInput extends Vue {
        @Prop()
        path: string[];

        @Prop()
        selFileName: string;

        @Prop()
        fileList: Array<any>;

        savename = "";
        // get fileSelect() {
        //     return this.$store.state.layout.filesSelected;
        // }
        get folderPath() {
            return this.path;
        }
        @Watch("selFileName")
        OnselFileNameChange(val) {
            if (val) {
                this.savename = val;
            }
        }
        get pcFileName() {
            return this.$store.state.pcFileName;
        }
        @Watch("pcFileName")
        OnpcFileNameChange(val) {
            if (val) {
                this.savename = val;
            }
        }
        // watch: {
        //     fileSelect() {
        //         if (this.fileSelect.length <= 0) {
        //             return;
        //         }
        //         this.savename = this.fileSelect[0].key.split("/").pop();
        //     },
        //     savename() {
        //         this.$nextTick(() => {
        //             this.$refs.nameIpt.focus();
        //         });
        //     }
        // },
        created() {
            let savename = new URLSearchParams(location.search.substr(1)).get("name");
            this.savename = savename ? savename : "";
            if (this.isPC && (<any>window).$qt && (<any>window).$qt.jsCallLoadFinished) {
                (<any>window).$qt.jsCallLoadFinished((data) => {
                    console.log("====================jsCallLoadFinished==================" + data);
                    this.savename = data;
                    console.log("-------------------toFocus");
                    this.$nextTick(() => {
                        (<any>this.$refs.nameIpt).focus();
                    });
                });
            }
            this.$nextTick(() => {
                (<any>this.$refs.nameIpt).focus();
            });
        }
        get limitFileNum() {
            return this.$store.state.limitFileNum || 3;
        }
        checkLimit() {
            return new Promise((rs, rj) => {
                this.$store
                    .dispatch("getUserLimit", this.$store.state.publicStore.runPlatform)
                    .then((res) => {
                        let num = res.data.limit;
                        this.$store.commit("setState", {
                            type: "limitFileNum",
                            data: num,
                        });
                        this.$store.commit("setState", {
                            type: "limitFileNowFileNum",
                            data: res.data.num,
                        });
                        if (res.data.num >= this.limitFileNum && !this.vip && this.$store.state.limitFileModalFlag) {
                            this.$store.commit("setState", {
                                type: "limitFileModalFlag",
                                data: false,
                            });
                            this.$bus.$on("limitModalContinue", () => {
                                console.log("on event");
                                this.$bus.$off("limitModalContinue");
                                this.saveNewFile();
                            });
                            this.$store.commit("setState", {
                                type: "showLimitFileModal",
                                data: true,
                            });
                            this.$store.commit("setState", {
                                type: "limitFileModalType",
                                data: "save",
                            });
                            rj();
                        } else if (res.data.is_over_limit) {
                            (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberLimit");
                            (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(3);
                            (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(3);
                            (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason("exceedsCloudFileNumber");
                            rj();
                        } else {
                            this.$store.commit("setState", {
                                type: "limitFileModalFlag",
                                data: true,
                            });
                            rs();
                        }
                    })
                    .catch((err) => {
                        rj();
                    });
            });
        }
        saveNewFile() {
            if (!this.$validateLogin()) return;
            if (!this.savename) {
                this.$edMessage.error(this.$t("nullName"));
                return;
            }

            let folderPath = this.folderPath.length ? this.folderPath.join("/") + "/" : "";

            let fileName = checkFileName(this.savename);
            if (!fileName) {
                this.$edMessage.error(this.$t("errorName"));
                return;
            }
            let limitFunc = (type = "") => {
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        console.log("on event");
                        this.$bus.$off("limitModalContinue");
                        this.saveNewFile();
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                    this.$store.commit("setState", {
                        type: "limitFileModalType",
                        data: "save",
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop", pcParams: { newUpgrade: 6, upgrade: 0 } });
                    }
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop", pcParams: { newUpgrade: 6, upgrade: 0 } });
                } else {
                    (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberPop");
                    (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(3);
                    (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(3);
                    (<any>window).$qt.jsCallUploadfailReason && (<any>window).$qt.jsCallUploadfailReason("exceedsCloudFileNumber");
                }
            };
            this.$openFile({
                params: "",
                fileType: "checkLimit",
                suffix: "",
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitFunc,
                vip: this.vip,
                isFullCouldSpace: this.isFullCouldSpace,
            }).then(() => {
                // this.checkLimit().then(()=>{
                let targetFileKey = folderPath + fileName;

                //判断是否重名
                let curFile = this.fileList;
                for (let i = 0; i < curFile.length; i++) {
                    let item = curFile[i],
                        key = item.name;
                    if (fileName == key) {
                        // this.$edMessage.error(this.$t("fileNameRepeatError"));
                        this.$Modal.confirm({
                            // title: this.$t("confirm.title"),
                            // content: this.$t("confirm.fileContent") + fileName + "?",
                            title: <string>this.$t("confirm.fileContent") + fileName + " ?",
                            okText: <string>this.$t("okText"),
                            cancelText: <string>this.$t("cancelText"),
                            closable: true,
                            loading: true,
                            onOk: () => {
                                this.$Modal.remove();
                                console.log("ok", targetFileKey);
                                this.$edMessage.loading({
                                    content: <string>this.$t("saving"),
                                    duration: 0,
                                });

                                (<any>window).$qt.jsCallCloudFileUpload(targetFileKey);
                            },
                        });
                        return;
                    }
                }

                console.log(targetFileKey);
                this.$edMessage.loading({ content: <string>this.$t("saving"), duration: 0 });
                (<any>window).$qt.jsCallCloudFileUpload(targetFileKey);
            });
        }
    }
</script>
